/* eslint-disable no-console */
import { t } from "i18next";
import { analytics } from "../../App";

const isValidUrl = (urlString: string) => {
	try {
		return Boolean(new URL(urlString));
	} catch (e) {
		return false;
	}
};

const track = (obj: any) => {
	analytics.track("Link Clicked", obj);
};

const trackItem = (item: any, location: string) => {
	const internalDomains = [
		"localhost",
		"cpcdevweb6.staplescan.com",
		"staples-canada-dev4.myshopify.com",
		"staples-canada-staging3.myshopify.com",
		"www.staging.staplescopyandprint.ca",
		"shop.staplescopyandprint.ca",
		"www.staplescopyandprint.ca"
	];

	let isExternal = false;
	let siteName;
	const url = item.url || item.href;

	if (url && isValidUrl(url)) {
		const destinationURL = new URL(url);
		isExternal = !internalDomains.includes(destinationURL.hostname);
		const pathname = destinationURL.pathname.toLowerCase();
		const hostname = destinationURL.hostname.toLowerCase();

		if (pathname.includes("/ops")) {
			siteName = "OPS";
		} else if (
			hostname.includes("staplescopyandprint.ca") ||
			hostname.toLowerCase().includes("myshopify.com")
		) {
			siteName = "Staples";
		} else {
			siteName = null;
		}
	}

	const win = window as any;
	const obj = {
		link_name:
			item.copy || item.title || item.altText || item.name || item.children,
		destination_url: item.url || item.href,
		link_location: location,
		external: isExternal,
		product_name: item.product_name || "",
		site: siteName
	};

	const parentUrl = win.iframeConfig?.parentUrl;
	const opts: any = {};
	if (parentUrl) {
		opts.context = {
			page: {
				url: parentUrl
			}
		};
	}

	if (
		(item.copy && item.copy === item.query) ||
		item.isProductSearch === true ||
		item.copy === "See all products"
	) {
		const productSearchedObj = {
			autocomplete: false,
			corrected_query: "",
			products: item.productList,
			query: item.query,
			site: siteName,
			see_all_products: true
		};

		analytics.track("Products Searched", productSearchedObj, opts);
	} else {
		analytics.track("Link Clicked", obj, opts);
	}

	if (item.copy === t("search.cta")) {
		const productObj = {
			brand: item.brand,
			category: item.category,
			list_id: "search",
			image_url: item.imageUrl,
			max_price: item.max_price,
			min_price: item.min_price,
			name: item.name,
			position: item.position,
			price: item.price,
			product_id: item.product_id,
			regular_price:
				item.min_price === item.max_price
					? parseFloat(item.regular_price)
					: null,
			sku: item.sku,
			url: item.url || item.href,
			variant: item.variant,
			site: siteName
		};

		const productSearchedObj = {
			autocomplete: false,
			corrected_query: "",
			query: item.query,
			products: item.productList,
			site: siteName,
			see_all_products: false
		};

		analytics.track("Product Clicked", productObj, opts);
		analytics.track("Products Searched", productSearchedObj, opts);
	}
};

const promoClicked = (data: any) => {
	analytics.track("Promotion Clicked", { ...data, site: "Staples" });
};
export { track, trackItem, promoClicked };
